let _nextId = 1;

export default {
  namespaced: true,

  state: () => ({
    jobs: [],
    panelOpen: false,
  }),

  getters: {
    running:      state => state.jobs.filter(j => j.status === 'running'),
    runningCount: (state, getters) => getters.running.length,
    hasAny:       state => state.jobs.length > 0,
  },

  mutations: {
    ADD(state, job) {
      state.jobs.push(job);
    },
    PATCH(state, { id, patch }) {
      const idx = state.jobs.findIndex(j => j.id === id);
      if (idx !== -1) state.jobs.splice(idx, 1, Object.assign({}, state.jobs[idx], patch));
    },
    REMOVE(state, id) {
      const idx = state.jobs.findIndex(j => j.id === id);
      if (idx !== -1) state.jobs.splice(idx, 1);
    },
    SET_PANEL(state, open) {
      state.panelOpen = open;
    },
  },

  actions: {
    add({ commit }, { label, type }) {
      const id = _nextId++;
      commit('ADD', { id, label, type, status: 'running', startedAt: Date.now() });
      commit('SET_PANEL', true);
      return id;
    },

    finish({ commit }, { id, success }) {
      commit('PATCH', { id, patch: { status: success ? 'done' : 'error', finishedAt: Date.now() } });
    },

    // Izleyen bilesen yikildi (sekme/rota degisti): is sunucuda surer ama burada takip edilemez.
    // Panel yalnizca running/done/error bilir; yanlis durum gostermemek icin kayit kaldirilir.
    detach({ commit }, { id }) {
      commit('REMOVE', id);
    },

    clearFinished({ commit, state }) {
      state.jobs
        .filter(j => j.status !== 'running')
        .forEach(j => commit('REMOVE', j.id));
    },

    togglePanel({ commit, state }) {
      commit('SET_PANEL', !state.panelOpen);
    },
  },
};
